module.exports = __webpack_public_path__ + "img/insurita-section-one-left.c77e00fd.svg";